import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import BugReport from "@mui/icons-material/BugReport";
//Limitless imports
import { withi18n } from "../../../../customer/components";
import FileAlt from "@limitless/icons/FileAlt";
const ConversationPlaceholder = ({
  classes,
  t,
  errorMode
}) => {
  const Icon = errorMode ? BugReport : FileAlt;
  const title = errorMode ? "An unexpected error occurred" : "Conversations will show here";
  const desc = errorMode ? "Please choose a different task" : "Please click on any task to see the details";
  return /*#__PURE__*/React.createElement("div", {
    className: classes.conversationPlaceholderContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.descriptionIcon
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textPrimary"
  }, t(title)), /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary"
  }, t(desc)));
};
const styles = theme => ({
  baseContainer: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    marginLeft: "2px",
    position: "relative"
  },
  conversationPlaceholderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    backgroundColor: theme.background.paper
  },
  descriptionIcon: {
    fontSize: 50
  }
});
export default withStyles(styles)(withi18n(ConversationPlaceholder));
ConversationPlaceholder.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  errorMode: PropTypes.bool.isRequired
};